import { render, staticRenderFns } from "./CasinoPromos.vue?vue&type=template&id=5b3e935a&scoped=true"
import script from "./CasinoPromos.vue?vue&type=script&lang=js"
export * from "./CasinoPromos.vue?vue&type=script&lang=js"
import style0 from "./CasinoPromos.vue?vue&type=style&index=0&id=5b3e935a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3e935a",
  null
  
)

export default component.exports